import { Box, Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";

interface GameInfoProps {
  points: string;
  rounds: string;
}

const GameInfo: React.FC<GameInfoProps> = ({ points, rounds }) => {
  return (
    <Flex
      position="fixed"
      top={4}
      left={4}
      right={4}
      justifyContent="space-between"
      zIndex={1000}
    >
      <InfoBlock label={t("game.stats.points")} value={points} />
      <InfoBlock label={t("game.stats.round")} value={rounds} />
    </Flex>
  );
};

interface InfoBlockProps {
  label: string;
  value: string;
}

const InfoBlock: React.FC<InfoBlockProps> = ({ label, value }) => {
  return (
    <Box
      bg="rgba(0, 0, 0, 0.7)"
      color="white"
      padding={2}
      borderRadius="md"
      width={{ base: "auto", md: "auto" }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection={{ base: "row", md: "column" }}
      >
        <Text fontSize="sm" fontWeight="bold" mr={{ base: 2, md: 0 }}>
          {label}:
        </Text>
        <Text fontSize={{ base: "lg", md: "2xl" }} fontWeight="bold">
          {value}
        </Text>
      </Flex>
    </Box>
  );
};

export default GameInfo;
